import { render, staticRenderFns } from "./editClb.vue?vue&type=template&id=9e08467e&scoped=true&"
import script from "./editClb.vue?vue&type=script&lang=js&"
export * from "./editClb.vue?vue&type=script&lang=js&"
import style0 from "./editClb.vue?vue&type=style&index=0&id=9e08467e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e08467e",
  null
  
)

export default component.exports